/* eslint-disable import/prefer-default-export */

import { any, arrayOf, shape, string } from 'prop-types';

export const SELECT_OPTION_SHAPE = shape({
  label: string.isRequired,
  value: any.isRequired
});

export const SELECT_OPTION_GROUP_SHAPE = shape({
  label: string.isRequired,
  options: arrayOf(SELECT_OPTION_SHAPE)
});
